import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=1dcac40d&scoped=true"
import script from "./InformationModal.vue?vue&type=script&lang=js"
export * from "./InformationModal.vue?vue&type=script&lang=js"
import style0 from "./InformationModal.vue?vue&type=style&index=0&id=1dcac40d&prod&lang=scss&scoped=true"
import style1 from "./InformationModal.vue?vue&type=style&index=1&id=1dcac40d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcac40d",
  null
  
)

export default component.exports